import React from 'react';
import { Button } from '@ok/okd';
import { toLocale } from '@common/i18n';
import { PAGE_PATH } from '../../common/context';
import styles from './index.module.less';

export default ({ title }) => {
  const { cdnBaseUrl } = window.okGlobal;
  return (
    <div className={styles['twitter-content']}>
      <div className={styles['twitter-title']}>{title}</div>
      <div className={styles['twitter-box']}>
        <div className={styles['twitter-info']}>
          <img
            src={`${cdnBaseUrl}/cdn/assets/imgs/currencyInfo/okcoinJapanIcon.png`}
            alt="twitter icon"
          />
          <div>
            <div>@OKJ</div>
            <div className={styles.brands}>X</div>
          </div>
        </div>
        <Button
          category={Button.CATEGORY.outline}
          type={Button.TYPE.primary}
          size={Button.SIZE.xs}
          href={PAGE_PATH.TWITTER}
          onClick={() => {
            window.seoMonitor.act('web_token_information_exposure');
          }}
        >
          {toLocale('currency_to_concern')}
        </Button>
      </div>
    </div>
  );
};
